const menuItem =[
    {
      "id": 1,
      "key": "dashboards",
      "label": "Dashboards",
      "icon": "airplay",
      "url": "/",
      "parentId": null
    },
    {
      "id": 2,
      "key": "manage-product",
      "label": "Manage Products",
      "icon": "box",
      "url": "/Manage-Product",
      "parentId": null
    },
    {
      "id": 3,
      "key": "enquiry",
      "label": "Enquiries",
      "icon": "list",
      "url": "/Enquiries",
      "parentId": null
    },
    
  ]
export default menuItem;  